module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 004.d299dc9e.jpg";